import { responseFormat } from '../Util/Util';
import api from './API';

const basePath = 'web-init';
const pathList = {
    settings: `/`
};

for(let key in pathList) {
    pathList[key] = basePath + pathList[key];
}

export const webInit = async () => {
    try {
        const apiPath = pathList.settings;
        const response = await api.getCall(apiPath);

        let data;

        if(response.hasOwnProperty('errorCode') && response.errorCode === 0) {
            data = response.data;
        }

        return responseFormat(0, 'Web Init success', data);
    } catch(e) {
        return responseFormat(-1, 'Failed to web init!', {});
    }
};